import { render } from "./permissions.vue?vue&type=template&id=2b99851e"
const script = {}

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__